import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import * as Yup from "yup";
import { useFormik } from "formik";
import { errorToast, getFromStorage, successToast } from "../../helpers";
import {
  UploadMedia,
  UploadMediaWithoutCompress,
} from "../../utils/uploadMedia";
import Loader from "../../helpers/Loader";
import {
  useLazyGetFormsByIdQuery,
  useUpdateFormsMultiMutation,
  useUpdateFormsMutation,
} from "../../services/forum";
import {
  useGetTutorListQuery,
  useLazyGetSubjectListQuery,
} from "../../services/class";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import {
  useGetCatSubListQuery,
  useLazyGetCatSubListQuery,
} from "../../services/category";
import {
  BULK_STATUS,
  CONTENT_TYPE,
  LISTING,
} from "../../helpers/constants/enums";
import EditText from "../../components/EditText";
import { classOptions as classOptionsImported } from "../manageClass/add";

interface VideoDetails {
  _id: string;
  images: string[];
  title: string;
  topic: string;
  description: string;
  allowComments: boolean;
  views: number;
  contentStatus: number;
  isAnonymous: boolean;
  status: boolean;
  createdAt: string;
  subjects: [
    {
      name: string;
      _id: string;
    },
  ];
  category: {
    name: string;
    _id: string;
  };
  grades: {
    name: string;
    _id: string;
  };
  gradeId: string;
  user: {
    _id: string;
    name: string;
    userName: string;
    email: string;
    phoneNo: string;
    dialCode: string;
    image: string;
  };
}

const classOptions = classOptionsImported?.map((item) => ({
  name: item?.label,
  _id: item?.value,
}));

const TeaserVideoForm = () => {
  const navigate = useNavigate();
  const { _id } = useParams();
  const [teaserVideo] = useLazyGetFormsByIdQuery();
  const [videoDetails, setVideoDetails] = useState<VideoDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [allSubject, setAllSubject] = useState<any>();
  const [allClass, setAllClass] = useState<any>();
  const [updateVideo] = useUpdateFormsMultiMutation();
  // const [updatedMulti] = useUpdateFormsMultiMutation();

  // Mock data for dropdowns
  const subjects = [
    { name: "Test" },
    { name: "English" },
    { name: "Math" },
    { name: "Science" },
  ];

  const grades = [{ name: "3" }, { name: "4" }, { name: "5" }, { name: "6" }];

  const tutors = [
    {
      _id: "68490f08c0061f8fce92dc85",
      name: "Testing Sharma",
      email: "testing2@yopmail.com",
    },
    {
      _id: "684a9d88082a346bd50eae6c",
      name: "Wow",
      email: "wow@yopmail.com",
    },
  ];
  // API calls
  const { data: tutorData } = useGetTutorListQuery();
  const [subjectApi] = useLazyGetCatSubListQuery();
  const { data: categoryData } = useGetCatSubListQuery({
    type: LISTING.CATEGORY,
  });
  const fetchSubjects = async () => {
    if (!formik.values.category) return;

    try {
      const response = await subjectApi({
        type: LISTING.SUBJECT,
        categoryId: formik.values.category,
      }).unwrap();

      if (response.statusCode === 200) {
        setAllSubject(response?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    try {
      if (_id) {
        setIsLoading(true);
        const response = await teaserVideo({ id: _id }).unwrap();
        if (response.statusCode === 200) {
          const data = response.data;
          setVideoDetails(data);

          formik.setFieldValue("category", data?.category?._id);
          formik.setFieldValue("grade", data?.gradeId);
          formik.setFieldValue("subject", data?.subjects[0]?._id);

          setSelectedCategory(data?.category?._id || "");
          setSelectedGrade(data?.gradeId || "");
          setSelectedSubject(data?.subjects[0]?._id || "");
          setSelectedTutor(data?.user?._id || "");
          // formik.setFieldValue("category", response.data?.category?._id);
          // formik.setFieldValue("grade", response.data?.gradeId);
          // formik.setFieldValue("subject", response.data?.subjects?._id);
          // formik.setValues({
          //   ...formik.values,
          //   video: response.data.images[0] || "",
          //   title: response.data.title || "",
          //   name: response.data.topic || "",
          //   description: response.data.description || "",
          //   subject: response.data.subjects?._id || "",
          //   grade: response.data.grades?._id || "",
          //   tutor: response.data.user._id || "",
          //   isAnonymous: response.data.isAnonymous || false,
          //   allowComments: response.data.allowComments || false,
          // });
          // setSelectedSubject(response.data.subjects?._id || "");
          // setSelectedGrade(response.data.grades?._id || "");
          // setSelectedTutor(response.data.user._id || "");
          // // Set availability based on isAnonymous
          // setSelectedAvailability(response.data.isAnonymous ? 1 : 0);
        }
      }
    } catch (error) {
      console.error(error);
      errorToast("Failed to fetch video details");
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [_id]);

  const handleVideoUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        formik.setFieldValue("video", "");
        return;
      }

      // Check file size (e.g., limit to 50MB)
      // const maxSize = 50 * 1024 * 1024; // 50MB in bytes
      // if (file.size > maxSize) {
      //   errorToast("Video file size should be less than 50MB");
      //   return;
      // }

      // Check file type
      const validTypes = ["video/mp4", "video/quicktime", "video/x-msvideo"];
      if (!validTypes.includes(file.type)) {
        errorToast("Only MP4, MOV, and AVI video formats are supported");
        return;
      }

      const res = await UploadMediaWithoutCompress(file);
      if (res?.statusCode === 200) {
        formik.setFieldValue("video", res?.data?.image);
      } else {
        errorToast(res?.message || "Error uploading video");
      }
    } catch (error) {
      console.error("Error uploading video:", error);
      errorToast("Error uploading video. Please try again.");
    }
  };

  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedTutor, setSelectedTutor] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedAvailability, setSelectedAvailability] = useState(0); // Default to 0 (Everyone)
  const handleAvailabilityChange = (event: any) => {
    const value = Number(event.target.value); // Convert to number
    setSelectedAvailability(value);
    formik.setFieldValue("isAnonymous", Boolean(value)); // Convert to boolean for formik
  };

  const handleSubjectChange = (event: any) => {
    setSelectedSubject(event.target.value);
    formik.setFieldValue("subject", event.target.value);
  };

  const handleCategoryChange = (event: any) => {
    setSelectedCategory(event.target.value);
    formik.setFieldValue("category", event.target.value);
  };

  const handleTutorChange = (event: any) => {
    setSelectedTutor(event.target.value);
    formik.setFieldValue("tutor", event.target.value);
  };

  const handleGradeChange = (event: any) => {
    setSelectedGrade(event.target.value);
    formik.setFieldValue("grade", event.target.value);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      video: videoDetails?.images?.[0] || "",
      title: videoDetails?.title || "",
      name: videoDetails?.topic || "",
      description: videoDetails?.description || "",
      subject: videoDetails?.subjects[0]?._id || "",
      grade: videoDetails?.gradeId || "",
      tutor: videoDetails?.user?._id || "",
      isAnonymous: videoDetails?.isAnonymous || false,
      allowComments: videoDetails?.allowComments || false,
      category: videoDetails?.category?._id,
    },
    //     {
    //     "userId": "68490f08c0061f8fce92dc85",
    //     "subjectId": "68490f74c0061f8fce92de46",
    //     "title": "title",
    //     "description": "description of forum",
    //     "images": ["image1", "image2"],
    //     "contentType": 3,
    //     "topic": "topic of class",
    //     "gradeId": "68490f74c0061f8fce92de52",
    //     "language": 1,
    //     "allowComments": true,
    //     "visibility": 1
    // }
    validationSchema: Yup.object().shape({
      title: Yup.string().required("Title is required"),
      name: Yup.string().required("Topic is required"),
      // description: Yup.string().required("Cust is required"),
      subject: Yup.string().required("Subject is required"),
      grade: Yup.string().required("Grade is required"),
      tutor: Yup.string().required("Tutor is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      if (!formik.isValid) return;

      setSubmitting(true);

      const body = {
        topic: values.name,
        title: values.title,
        description: values.description,
        images: values.video ? [values.video] : [],
        contentType: CONTENT_TYPE.TEASER_VIDEO,
        categoryId: values.category,
        subjectId: [values.subject],
        gradeId: values.grade,
        isAnonymous: Boolean(values.isAnonymous),
        allowComments: values.allowComments,
        type: BULK_STATUS.UPDATE,
        ids: [_id],
      };

      // return;
      // try {

      //   successToast(
      //     _id ? "Video updated successfully" : "Video created successfully"
      //   );
      //   navigate("/manage-videos");
      // } catch (error: any) {
      //   console.error("Error submitting form:", error);
      //   errorToast(error?.message || "An error occurred");
      // } finally {
      //   setSubmitting(false);
      // }
      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response: any = await updateVideo({
          body: encryptedBody,
          // id: _id,
        }).unwrap();
        if (response?.statusCode === 200) {
          successToast("Video updated successfully");
          navigate("/manage-videos");
        }
      } catch (error: any) {
        console.error("Error adding video:", error);
        errorToast(error?.data?.message || "");
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (formik.values.category) {
      fetchSubjects();
    }
  }, [formik.values.category]);

  useEffect(() => {
    setAllClass(classOptions);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <MainContainer>
      <div className="main_loyout">
        <Card className="cards">
          <div className="dashboard">
            {_id ? (
              <h1 className="mn_hdng">Edit Video</h1>
            ) : (
              <h1 className="mn_hdng">Add Video</h1>
            )}
            <Loader isLoad={isLoading} />
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-videos");
              }}
            >
              Back
            </Button>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <CardContent sx={{ p: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography className="custom_label">Video</Typography>
                  {formik.values.video ? (
                    <div className="upload_image_preview">
                      <video
                        style={{
                          width: 350,
                          height: 150,
                          borderRadius: 0,
                        }}
                        src={formik.values.video}
                        controls
                      />
                      <CancelIcon
                        sx={{
                          zIndex: 1000,
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("video", "");
                        }}
                      />
                    </div>
                  ) : (
                    <Box className="upload_image">
                      <label htmlFor="icon-button-file-video">
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file-video"
                          type="file"
                          inputProps={{
                            accept: "video/mp4",
                          }}
                          onChange={handleVideoUpload}
                        />
                        <Button component="span" className="upload_image_btn">
                          <img
                            style={{
                              width: 350,
                              height: 150,
                              borderRadius: 0,
                            }}
                            src={`/static/images/document.png`}
                            alt=""
                          />
                          <CameraAltIcon />
                        </Button>
                      </label>
                    </Box>
                  )}
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Tutor</Typography>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      className="select_div"
                      fullWidth
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedTutor}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      disabled={Boolean(_id)}
                      displayEmpty
                      onChange={handleTutorChange}
                    >
                      <MenuItem value="" disabled>
                        Select Tutor
                      </MenuItem>
                      {tutorData?.data?.map((tutor: any) => (
                        <MenuItem key={tutor._id} value={tutor._id}>
                          {tutor.name} ({tutor.userName})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {formik.touched.tutor && formik.errors.tutor && (
                    <div className="err_msg">{formik.errors.tutor}</div>
                  )}
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Title</Typography>
                  <TextField
                    className="text_field"
                    hiddenLabel
                    type={"text"}
                    name="title"
                    variant="outlined"
                    fullWidth
                    id="title"
                    placeholder="Title"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.title}
                    helperText={
                      formik.touched.title && formik.errors.title
                        ? formik.errors.title.toString()
                        : ""
                    }
                  />
                </Grid>
                {/* topic */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Topic</Typography>
                  <TextField
                    className="text_field"
                    hiddenLabel
                    type={"text"}
                    name="name"
                    variant="outlined"
                    fullWidth
                    id="name"
                    placeholder="Topic"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    helperText={
                      formik.touched.name && formik.errors.name
                        ? formik.errors.name.toString()
                        : ""
                    }
                  />
                </Grid>
                {/* category */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Category</Typography>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      className="select_div"
                      fullWidth
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedCategory}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      onChange={handleCategoryChange}
                    >
                      <MenuItem value="" disabled>
                        Select Category
                      </MenuItem>
                      {categoryData?.data?.map((item: any) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {formik.touched.category && formik.errors.category && (
                    <div className="err_msg">{formik.errors.category}</div>
                  )}
                </Grid>
                {/* subject */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Subject</Typography>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      className="select_div"
                      fullWidth
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedSubject}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      onChange={handleSubjectChange}
                    >
                      <MenuItem value="" disabled>
                        Select Subject
                      </MenuItem>
                      {allSubject?.map((item: any) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {formik.touched.subject && formik.errors.subject && (
                    <div className="err_msg">{formik.errors.subject}</div>
                  )}
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Grade</Typography>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      className="select_div"
                      fullWidth
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedGrade}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      onChange={handleGradeChange}
                    >
                      <MenuItem value="" disabled>
                        Select Grade
                      </MenuItem>
                      {allClass?.map((item: any) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {formik.touched.grade && formik.errors.grade && (
                    <div className="err_msg">{formik.errors.grade}</div>
                  )}
                </Grid>

                {/* <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Video Availability
                  </Typography>
                  <FormControl sx={{ width: "100%" }}>
                    <Select
                      className="select_div"
                      fullWidth
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedAvailability}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                      displayEmpty
                      onChange={handleAvailabilityChange}
                    >
                      <MenuItem value={0}>Everyone</MenuItem>
                      <MenuItem value={1}>Private</MenuItem>
                    </Select>
                  </FormControl>
                </Grid> */}

                {/* comments */}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formik.values.allowComments}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "allowComments",
                            e.target.checked
                          )
                        }
                        name="allowComments"
                        color="primary"
                      />
                    }
                    label="Allow Comments"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className="custom_label">Custom Note</Typography>
                  {formik.values.description && (
                    <EditText
                      content={formik.values.description}
                      setContent={(value) =>
                        formik.setFieldValue("description", value)
                      }
                    />
                  )}
                  {/* <TextField
                    className="text_field"
                    hiddenLabel
                    type={"text"}
                    name="description"
                    multiline
                    minRows={4}
                    maxRows={6}
                    variant="outlined"
                    fullWidth
                    id="description"
                    placeholder="Description"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description}
                    helperText={
                      formik.touched.description && formik.errors.description
                        ? formik.errors.description.toString()
                        : ""
                    }
                  /> */}
                </Grid>

                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </Grid>
            </CardContent>
          </form>
        </Card>
      </div>
    </MainContainer>
  );
};

export default TeaserVideoForm;
